import React from "react";
import useResponsive from "../../hooks/useResponsive";

const Tooltip = ({
  content,
  place = "bottom",
  id = "main-tooltip",
  enableMobile = false,
  children,
}) => {
  const { type } = useResponsive();
  return (
    <>
      {React.Children.map(children, (child) => {
        if (!type.desktop && !enableMobile) return React.cloneElement(child);
        return React.cloneElement(child, {
          "data-tooltip-id": id,
          "data-tooltip-content": content,
          "data-tooltip-place": place,
        });
      })}
    </>
  );
};

export default Tooltip;
